import {
  getUserData,
  getQuotation,
  setQuestionVisibility,
  getCarData,
  changeFieldValue,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum, MessagesEnum } from 'app/shared/enums';

const vin = {
  calculationCarVinChange(initialRun?: boolean) {
    const { vin: carVin } = getCarData();
    const formattedVin = carVin ? carVin.toUpperCase() : '';

    if (carVin) {
      changeFieldValue(
        FieldsEnum.CarVin,
        formattedVin,
        FormsEnum.CalculationForm
      );
    }

    setMessageVisibility({
      key: MessagesEnum.ShortMotorcycleVinInfo,
      visible:
        Boolean(formattedVin) &&
        !formattedVin.includes('***') &&
        formattedVin.length >= 4 &&
        formattedVin.length < 17,
      formName: FormsEnum.CalculationForm,
    });
  },

  setVinVisibleForOperators(initialRun?: boolean) {
    if (!initialRun) {
      return;
    }

    const isOperator = getUserData().user?.operator;
    const quotation = getQuotation();
    const isRenewal = !!(quotation.renewal && !quotation.externalRenewal);

    if (isOperator || isRenewal) {
      setQuestionVisibility({
        key: FieldsEnum.CarVin,
        visible: true,
        formName: FormsEnum.CalculationForm,
      });
    }
  },
};

export default vin;
